import { ProductType } from './product.model';

export function getLocalizedProducts(): Record<ProductType, string> {
    return {
        PERSONAL_TAX: $localize`:@@localizedProductNames.personalTax:Personenbelasting`,
        SCENARIOS: $localize`:@@localizedProductNames.scenarios:Scenario\'s`,
        DEPRECIATIONS: $localize`:@@localizedProductNames.depreciations:Afschrijvingstabellen`,
        VAT_IMPORT: $localize`:@@localizedProductNames.vatImport:BTW Reconciliatie`,
        DOC_IMPORT: $localize`:@@localizedProductNames.docImport:MyMinFin documenten`,
        BUDGET_IMPORT: $localize`:@@localizedProductNames.budgetImport:Importeren van budgetten`,
        NON_PROFIT: $localize`:@@localizedProductNames.nonProfit:VZW`,
        KNOWLEDGE_CENTER: $localize`:@@localizedProductNames.knowledgeCenter:Athena`,
        ANNUAL_REPORT: $localize`:@@localizedProductNames.annualReport:Cijferanalyse`,
    };
}
